<template>
  <div :class="['dot', extraData.color]" @click="show">
    {{ data.name ? data.name.substring(0, 1) : '' }}
    <div class="dot_detail" ref="dotDetail" v-show="extraData.infoBar && (accordion ? extraData.color === 'red' : false)">
      <i class="el-icon-close close" @click.stop="hide"></i>
      <p>名称：{{ data.name || '未知' }}</p>
      <p>地址：{{ data.address || '未知' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'window',
  props: {
    accordion: {
      require: false,
      type: Boolean,
      default: true
    },
    data: {},
    extraData: {}
  },
  watch: {
    extraData(n) {
      if (n.infoBar && (this.accordion ? n.color === 'red' : false)) this.show()
      else this.hide()
    }
  },
  methods: {
    show() {
      this.$refs.dotDetail.style.display = 'block'
      // 可以设置一个回调
      this.$emit('dotClickCallback', ...this.extraData)
    },
    hide() {
      this.$refs.dotDetail.style.display = 'none'
    }
  }
}
</script>

<style lang="less" scoped>
.dot {
  width: 20px;
  height: 20px;
  color: #fff;
  line-height: 20px;
  text-align: center;
  border-radius: 10px;
  background: #35b9f7;
  position: relative;
  cursor: pointer;
  pointer-events: auto;
  .dot_detail {
    width: 240px;
    min-width: 200px;
    height: 60px;
    background: #fff;
    font-size: 12px;
    text-align: left;
    background-size: 100%;
    padding: 8px;
    border: 1px solid #d7d7d7;
    border-radius: 4px;
    color: #666;
    position: absolute;
    left: -14px;
    top: -76px;
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .close {
      width: 10px;
      height: 10px;
      float: right;
    }
  }
  .dot_detail::before {
    content: '';
    width: 0;
    height: 0;
    border-width: 10px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
    // transform:rotate(45deg);
    position: absolute;
    left: 12px;
    top: 58px;
  }
}
.dot.blue {
  background: #35b9f7;
}
.dot.red {
  background: #c42135;
}
</style>



// WEBPACK FOOTER //
// src/components/public/window/index.vue